module.exports = __webpack_public_path__ + "static/media/sombra-lombada-interna.547e9a17.svg";